exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-type[data-v-76910743] {\n  margin-top: 10px;\n}\n", ""]);

// exports
